import { PageContent, PageHeader } from '@/components';
import { useCreateBreadcrumbs } from '@/hooks/creaet-breadcrumbs';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTab } from '../../_components/HeaderTab';
import { useSnapshotTitle } from '../../_hooks/snapshot-title';
import { OrganizationsTable } from '../_components/OrganizationsTable';

export const SnapshotOrganizationsPage: FC = () => {
  const { t } = useTranslation();
  const { title } = useSnapshotTitle();
  const { createBreadcrumb } = useCreateBreadcrumbs({ baseIndex: 3 });

  return (
    <>
      <PageHeader
        title={title}
        breadcrumbs={createBreadcrumb([
          { title: t('tenant-manager-root-page') },
          { title: t('snapshots-name') },
        ])}
      />
      <PageContent>
        <HeaderTab type="organizations" />
        <OrganizationsTable />
      </PageContent>
    </>
  );
};
